module.exports = __webpack_public_path__ + "img/logo.988b2505.png";